/* AzaanWalls — interactions: reveal-on-scroll, hero carousel, drawer, countdown,
   wishlist hearts, product gallery / variants / ajax add-to-cart, delivery estimate, sticky bar */
(function () {
  'use strict';
  var d = document;
  d.documentElement.classList.add('aw-js');

  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  /* ---------------- reveal on scroll ---------------- */
  var io = null;
  function initReveal() {
    var els = $$('.aw-reveal:not(.is-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
    }
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () {
      $$('.aw-reveal:not(.is-visible)').forEach(function (e) {
        var r = e.getBoundingClientRect();
        if (r.top < window.innerHeight) e.classList.add('is-visible');
      });
    }, 2500);
  }

  /* ---------------- hero carousel ---------------- */
  function initHero() {
    $$('[data-aw-hero]').forEach(function (h) {
      if (h.__aw) return; h.__aw = 1;
      var slides = $$('.aw-hero-slide', h);
      var dots = $$('.aw-hero-dot', h);
      var ms = (parseFloat(h.getAttribute('data-autoplay')) || 0) * 1000;
      var i = 0, timer = null, startX = null;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
      }
      function stop() { clearInterval(timer); }
      function play() { stop(); if (ms && slides.length > 1) timer = setInterval(function () { go(i + 1); }, ms); }
      h.addEventListener('click', function (e) {
        if (e.target.closest('.aw-hero-arrow.next')) { go(i + 1); play(); }
        else if (e.target.closest('.aw-hero-arrow.prev')) { go(i - 1); play(); }
        else {
          var dot = e.target.closest('.aw-hero-dot');
          if (dot) { go(dots.indexOf(dot)); play(); }
        }
      });
      h.addEventListener('mouseenter', stop);
      h.addEventListener('mouseleave', play);
      h.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
      h.addEventListener('touchend', function (e) {
        if (startX !== null) {
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 50) go(dx < 0 ? i + 1 : i - 1);
        }
        startX = null; play();
      }, { passive: true });
      play();
    });
  }

  /* ---------------- countdown ---------------- */
  function initTimers() {
    $$('[data-aw-countdown]').forEach(function (el) {
      if (el.__aw) return; el.__aw = 1;
      var end = Date.parse(el.getAttribute('data-aw-countdown'));
      var ended = el.getAttribute('data-ended') || 'Promotion ended';
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var s = Math.floor((end - Date.now()) / 1000);
        if (isNaN(end) || s <= 0) { el.textContent = ended; clearInterval(el.__t); return; }
        el.textContent = pad(Math.floor(s / 3600)) + ' Hrs : ' + pad(Math.floor((s % 3600) / 60)) + ' Min : ' + pad(s % 60) + ' Sec';
      }
      tick();
      el.__t = setInterval(tick, 1000);
    });
  }

  /* ---------------- wishlist hearts (stored in the browser only) ---------------- */
  function wishlist() { try { return JSON.parse(localStorage.getItem('aw_wishlist') || '[]'); } catch (e) { return []; } }
  function saveWishlist(a) { try { localStorage.setItem('aw_wishlist', JSON.stringify(a)); } catch (e) {} }
  function initHearts() {
    var list = wishlist();
    $$('[data-aw-heart]').forEach(function (b) {
      b.classList.toggle('is-on', list.indexOf(b.getAttribute('data-aw-heart')) > -1);
    });
  }

  /* ---------------- toast ---------------- */
  var toastTimer = null;
  function toast(html) {
    var t = $('.aw-toast');
    if (!t) { t = d.createElement('div'); t.className = 'aw-toast aw'; d.body.appendChild(t); }
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
  }

  function refreshCartCount() {
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-aw-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
        return c;
      });
  }

  /* ---------------- product page ---------------- */
  function pad2(n) { return n < 10 ? '0' + n : '' + n; }
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addDays(date, n) { var x = new Date(date.getTime()); x.setDate(x.getDate() + n); return x; }
  function fmtLong(x) { return MONTHS[x.getMonth()] + ' ' + x.getDate() + ', ' + x.getFullYear(); }
  function fmtRange(a, b) {
    if (a.getTime() === b.getTime()) return MONTHS[a.getMonth()] + ' ' + a.getDate();
    if (a.getMonth() === b.getMonth()) return MONTHS[a.getMonth()] + ' ' + a.getDate() + ' - ' + b.getDate();
    return MONTHS[a.getMonth()] + ' ' + a.getDate() + ' - ' + MONTHS[b.getMonth()] + ' ' + b.getDate();
  }

  function initEta(p) {
    var box = $('[data-aw-eta]', p);
    if (!box || box.__aw) return; box.__aw = 1;
    var pmin = +box.getAttribute('data-proc-min') || 1, pmax = +box.getAttribute('data-proc-max') || 4;
    var dmin = +box.getAttribute('data-del-min') || 5, dmax = +box.getAttribute('data-del-max') || 6;
    function set(sel, txt) { var n = $(sel, p); if (n) n.textContent = txt; }
    function render() {
      var now = new Date();
      var mid = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      var mins = Math.max(0, Math.floor((mid - now) / 60000));
      set('[data-eta-left]', Math.floor(mins / 60) + 'h ' + (mins % 60) + 'min');
      set('[data-eta-from]', fmtLong(addDays(now, dmin)));
      set('[data-eta-to]', fmtLong(addDays(now, dmax)));
      set('[data-track-today]', MONTHS[now.getMonth()] + ' ' + now.getDate());
      set('[data-track-proc]', fmtRange(addDays(now, pmin), addDays(now, pmax)));
      set('[data-track-del]', fmtRange(addDays(now, dmin), addDays(now, dmax)));
    }
    render();
    setInterval(render, 30000);
  }

  function initProduct() {
    $$('[data-aw-product]').forEach(function (p) {
      if (p.__aw) return; p.__aw = 1;
      var form = $('#aw-product-form', p);
      var variants = [];
      var vjson = $('script[data-aw-variants]', p);
      try { variants = JSON.parse(vjson ? vjson.textContent : '[]'); } catch (e) {}
      var thumbs = $$('.aw-pd-thumb', p);
      var imgs = $$('.aw-pd-main img', p);
      var cur = 0;

      function showImage(n) {
        if (!imgs.length) return;
        cur = (n + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === cur); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
      }

      function selectedOptions() {
        return $$('[data-aw-option]', p).map(function (g) {
          var a = $('.aw-swatch.is-active', g);
          return a ? a.getAttribute('data-value') : null;
        });
      }

      function applyVariant() {
        var sel = selectedOptions();
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        })[0];
        var idInput = $('[name=id]', p);
        var priceEl = $('[data-aw-price]', p);
        var stockEl = $('[data-aw-stock]', p);
        var stockTxt = stockEl ? $('span', stockEl) : null;
        var addBtn = $('[name=add]', p);
        var buyBtn = $('[name=checkout]', p);
        var sticky = $('[data-aw-sticky-price]', d);
        if (!v) {
          if (stockEl) { stockEl.classList.add('is-out'); if (stockTxt) stockTxt.textContent = 'Unavailable'; }
          [addBtn, buyBtn].forEach(function (b) { if (b) b.disabled = true; });
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = (v.onSale ? '<s>' + v.compare + '</s>' : '') + '<b>' + v.price + '</b>';
        if (sticky) sticky.textContent = v.price;
        if (stockEl) {
          stockEl.classList.toggle('is-out', !v.available);
          if (stockTxt) stockTxt.textContent = v.available ? 'In Stock' : 'Sold out';
        }
        if (addBtn) { addBtn.disabled = !v.available; var lbl = $('span', addBtn); if (lbl) lbl.textContent = v.available ? addBtn.getAttribute('data-label') : 'Sold out'; }
        if (buyBtn) buyBtn.disabled = !v.available;
        if (v.image) {
          var k = thumbs.map(function (t) { return t.getAttribute('data-image-id'); }).indexOf(String(v.image));
          if (k > -1) showImage(k);
        }
        try {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }

      p.addEventListener('click', function (e) {
        var sw = e.target.closest('.aw-swatch');
        if (sw && !sw.disabled) {
          var g = sw.closest('[data-aw-option]');
          $$('.aw-swatch', g).forEach(function (x) { x.classList.remove('is-active'); });
          sw.classList.add('is-active');
          var lab = $('.aw-label span', g.parentNode);
          if (lab) lab.textContent = sw.getAttribute('data-value');
          applyVariant();
          return;
        }
        var th = e.target.closest('.aw-pd-thumb');
        if (th) { showImage(thumbs.indexOf(th)); return; }
        if (e.target.closest('.aw-pd-prev')) { showImage(cur - 1); return; }
        if (e.target.closest('.aw-pd-next')) { showImage(cur + 1); return; }
        var q = e.target.closest('[data-aw-qty]');
        if (q) {
          var inp = $('[name=quantity]', p);
          inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(q.getAttribute('data-aw-qty'), 10));
          return;
        }
        if (e.target.closest('.aw-pd-zoom') || (e.target.closest('.aw-pd-main') && e.target.tagName === 'IMG')) {
          var lb = $('.aw-lightbox', d);
          if (lb && imgs[cur]) {
            $('img', lb).src = imgs[cur].getAttribute('data-zoom') || imgs[cur].src;
            lb.classList.add('is-open');
          }
        }
      });

      /* ajax add to cart (Buy Now goes straight to checkout) */
      if (form) {
        form.addEventListener('submit', function (e) {
          var sub = e.submitter;
          if (sub && sub.name === 'checkout') return;
          e.preventDefault();
          var btn = $('[name=add]', form);
          if (btn) btn.disabled = true;
          fetch(rootUrl() + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (!res.ok) { toast(res.j.description || 'Could not add this item.'); return; }
              return refreshCartCount().then(function () {
                toast('Added to your cart &nbsp;<a href="' + rootUrl() + 'cart">View cart</a>');
              });
            })
            .catch(function () { form.submit(); })
            .then(function () { if (btn) btn.disabled = false; });
        });
      }

      /* sticky buy bar */
      var zone = $('[data-aw-buyzone]', p);
      var bar = $('.aw-sticky', d);
      if (zone && bar && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e0 = en[0];
          bar.classList.toggle('is-on', !e0.isIntersecting && e0.boundingClientRect.top < 0);
        }).observe(zone);
        var sbtn = $('[data-aw-sticky-add]', bar);
        if (sbtn && form) sbtn.addEventListener('click', function () {
          var add = $('[name=add]', form);
          if (form.requestSubmit) form.requestSubmit(add); else if (add) add.click();
        });
      }

      initEta(p);
    });
  }

  /* ---------------- global delegated clicks ---------------- */
  d.addEventListener('click', function (e) {
    var open = e.target.closest('[data-aw-drawer-open]');
    if (open) { var dr = $('.aw-drawer'); if (dr) dr.classList.add('is-open'); return; }
    if (e.target.closest('[data-aw-drawer-close]')) { var dc = $('.aw-drawer'); if (dc) dc.classList.remove('is-open'); return; }
    var lb = e.target.closest('.aw-lightbox');
    if (lb) { lb.classList.remove('is-open'); return; }
    var h = e.target.closest('[data-aw-heart]');
    if (h) {
      e.preventDefault();
      var key = h.getAttribute('data-aw-heart');
      var list = wishlist();
      var at = list.indexOf(key);
      if (at > -1) list.splice(at, 1); else list.push(key);
      saveWishlist(list);
      h.classList.toggle('is-on', at === -1);
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.aw-drawer.is-open, .aw-lightbox.is-open').forEach(function (n) { n.classList.remove('is-open'); });
    }
  });

  /* ---------------- boot ---------------- */
  function init() { initReveal(); initHero(); initTimers(); initHearts(); initProduct(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);
})();
